import React from 'react';
import './AddEvents.css';
import { AiFillCalendar } from "react-icons/ai";
import { ImNewTab } from "react-icons/im";

export default function AddEvents() {
  return (
    <div className="add-events-container">
      <div className="page-header">
        <h1>Add Events</h1>
        <p>Create and schedule new events</p>
      </div>
      
      <div className="page-content">
        <p>
          To add CAPT Events to your calendar,{" "}
          <a
            href="https://calendar.google.com/calendar/u/0?cid=YmI1OTBjOTUyMjIxZDI0MzBiZTAyOWI4MzY2Mjg5OWQyZmM4OTQyMzYwODU3NDljYjZiMDAyZWI0OGE5ZGFkMkBncm91cC5jYWxlbmRhci5nb29nbGUuY29t"
            target="_blank"
            rel="noopener noreferrer"
          >
            click here <AiFillCalendar />
          </a>
        </p>
        <p>
          To open calendar in another tab,{" "}
          <a
            href="https://calendar.google.com/calendar/u/0/embed?src=bb590c952221d2430be029b83662899d2fc894236085749cb6b002eb48a9dad2@group.calendar.google.com&ctz=Asia/Singapore"
            target="_blank"
            rel="noopener noreferrer"
          >
            click here <ImNewTab />
          </a>
        </p>
        <div className="calendar-wrapper">
          <iframe
            src="https://calendar.google.com/calendar/embed?src=bb590c952221d2430be029b83662899d2fc894236085749cb6b002eb48a9dad2%40group.calendar.google.com&ctz=Asia%2FSingapore"
            frameBorder="0"
            scrolling="no"
            title="Google Calendar"
          />
        </div>
      </div>
    </div>
  );
}
